import * as React from "react";

const Entry: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14Z"
      fill="#4E5B6F"
    />
    <path
      d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
      fill="#4E5B6F"
    />
    <path
      d="M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z"
      fill="#4E5B6F"
    />
    <path
      d="M8 10V8M4 6C4 6 4 6.31304 4 6.66667C4 7.02029 4.14048 7.35943 4.39052 7.60948C4.64057 7.85952 4.97971 8 5.33333 8H10.6667C11.0203 8 11.3594 7.85952 11.6095 7.60948C11.8595 7.35943 12 7.02029 12 6.66667V6"
      stroke="#4E5B6F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Entry;
